// @flow
import * as React from 'react';
import styled from 'styled-components';
import { below } from "../../assets/css/media";
import colors from "../../assets/css/colors";
import ModalOverlay from './ModalOverlay';
import ModalClose from './ModalClose';
import ModalHeader from './ModalHeader';
import ModalBody from './ModalBody';

export const ModalContainerStyled = styled.div`
	max-width: 799px;
	z-index: 1000;
	width: ${({ width }) => width ? width : '100%'};
	margin: 0 20px;
	background-color: ${colors.lightGrey};
	box-shadow: 0 0 20px 0 rgba(0,0,0,0.15);
	position: relative;

	${below.tablet`
		max-width: 300px;
	`}
`;

type Props = {
	header_text?: string,
	is_sponsored?: boolean,
	popup_width?: string,
	onClick: Function,
	body_class?: string,
	children: React.Node
};

export const ModalContainer =
	({ header_text, is_sponsored, onClick, popup_width,...props }: Props) => (
		<ModalOverlay>
			<ModalContainerStyled
				width={popup_width}
			>
				<ModalClose onClick={onClick} />

				{header_text ?
					<ModalHeader header_text={header_text} is_sponsored={is_sponsored} />
					: null}

				<ModalBody
					className={ props.body_class ? props.body_class : 'modal-body'} >
					{props.children}
				</ModalBody>

			</ModalContainerStyled>
		</ModalOverlay>
	);

export default ModalContainer;


// WEBPACK FOOTER //
// ./src/components/Modal/ModalContainer.js